// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__J_CAv","col":"styles_col__2TZZI"};